import { useDispatch } from 'react-redux';
import { REFER_A_FRIEND } from 'resources/Referral/Data';

import BrowserPush from '@/BrowserPush';
import RedirectTo from 'components/Common/RedirectTo';

import { NAVBAR_MENU, REFERRAL_PROGRAM, trackButtonClicked } from '../../Services/Analytics/TrackEventsService';

const AvatarShortcutStates = ({ toggleActivityFeedDrawer, toggleTasksDrawer }) => {
  const dispatch = useDispatch();

  return [
    {
      onClick: () => {
        dispatch(trackButtonClicked('Activity feed'));
        toggleActivityFeedDrawer();
      },
      title: 'Activity feed',
    },
    {
      onClick: () => {
        dispatch(trackButtonClicked('help center', { button_location: NAVBAR_MENU }));
        RedirectTo.helpCenter();
      },
      title: 'Help',
    },
    {
      onClick: () => toggleTasksDrawer(),
      title: 'Tasks',
    },
    {
      onClick: () => dispatch(trackButtonClicked(REFERRAL_PROGRAM, { button_location: 'navbar menu' })),
      href: '/pro/account/referrals',
      title: REFER_A_FRIEND,
    },
    {
      onClick: async () => {
        await BrowserPush.disconnect();
        window.location.href = '/pro/log_out';
      },
      title: 'Sign out',
    },
  ];
};

export default AvatarShortcutStates;
